import { Serializable } from "./load/serializable.js";
import { HumanMessage, AIMessage } from "./messages/index.js";
/**
 * Base class for all chat message histories. All chat message histories
 * should extend this class.
 */
export class BaseChatMessageHistory extends Serializable {
}
/**
 * Base class for all list chat message histories. All list chat message
 * histories should extend this class.
 */
export class BaseListChatMessageHistory extends Serializable {
    addUserMessage(message) {
        return this.addMessage(new HumanMessage(message));
    }
    addAIChatMessage(message) {
        return this.addMessage(new AIMessage(message));
    }
}
